import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';

/*
 * Props.
 */

interface ContactCardFooterOpenDetailsProps {
  onOpenContactDetails: Handler;
}

/*
 * Style.
 */

const StyledOpenDetailsWrapperDiv = styled.div`
  display: flex;
`;

/*
 * Component.
 */

export const ContactCardFooterOpenDetails: FC<ContactCardFooterOpenDetailsProps> = (props) => {
  const {onOpenContactDetails} = props;
  return (
    <StyledOpenDetailsWrapperDiv>
      <Button onClick={onOpenContactDetails}>
        <Trans id="contact-card-open-details-button">Open details</Trans>
      </Button>
    </StyledOpenDetailsWrapperDiv>
  );
};
